import React from "react";
import {FutureDayBar} from "./day_bars/FutureDayBar";
import {TYPE_CAMPAIGNS_CONFIGURATION} from "../../DashboardRow";
import {DashboardCell} from "../base/DashboardCell";

export class DashboardBarsCell extends DashboardCell {
    _shouldRenderEmptyCell() {
        return this.props.data === null || this.props.data.alerts_by_day === undefined || this.props.data.alerts_by_day === null;
    }

    barsForPastDaysAndToday() {
        const dayNumbersOfPeriod = Object.keys(this.props.data.alerts_by_day);
        const currentDayOfPeriod = dayNumbersOfPeriod.length;

        return dayNumbersOfPeriod.map(dayNumber => {
            const rowType = this.props.rowType;
            dayNumber = parseInt(dayNumber, 10);
            const isToday = currentDayOfPeriod === dayNumber + 1;
            const alertData = this.props.data.alerts_by_day[dayNumber];
            const alertLevel = this.getAlertLevel(rowType, alertData);
            const alert_snoozed = this.props.data.alert_snoozed;

            return this.renderDayBar(dayNumber, alertLevel, alertData, isToday, alert_snoozed, rowType)
        });
    }

    getAlertLevel(rowType, alertData) {
        if(rowType === TYPE_CAMPAIGNS_CONFIGURATION || alertData.fluctuation === "undefined")
            return "no-data";
        return alertData.level;
    }

    addFutureDaysBars(pastAndTodayBars) {
        let pastAndTodayNumberOfBars = pastAndTodayBars.length
        for (let i = 0; i < this.props.data.remaining_days_of_current_period; i++) {
            pastAndTodayBars.push(<FutureDayBar key={pastAndTodayNumberOfBars + i}/>)
        }

        return pastAndTodayBars;
    }

    render() {
        let pastAndTodayBars = this.barsForPastDaysAndToday();
        const budgetBars = this.addFutureDaysBars(pastAndTodayBars);

        return (
            <td className="graphic-data">
                <div className="graphic-budget">
                    {budgetBars}
                </div>
            </td>
        );
    }

    renderDayBar(dayNumber, alertLevel, alertData, isToday, alert_snoozed, rowType) {
        throw new Error('This method must be overridden in the concrete component.');
    }
}
